import React from 'react';
import { FormBuilder } from 'commons-ui';
import useEdit from './useEdit';
import { FORM_FIELD_EDIT_CONFIG, FORM_LAYOUT_EDIT_CONFIG, validationSchema } from '../../utils/formConfig';

const EditPaymentPGFailure: React.FC<{}> = () => {
	const { showLoader, handleFormSubmit, handleFormCancel, setShowLoader, data } = useEdit();
	return (
		<FormBuilder
			data={data}
			mode='edit'
			showLoader={showLoader}
			handleFormSubmit={handleFormSubmit}
			handleFormCancel={handleFormCancel}
			validationSchema={validationSchema}
			setShowLoader={setShowLoader}
			fieldConfig={FORM_FIELD_EDIT_CONFIG}
			layoutConfig={FORM_LAYOUT_EDIT_CONFIG}
			buttonLabels={{
				submitLabel: 'Submit',
				discardLabel: 'Cancel'
			}}
		/>
	);
};

export default EditPaymentPGFailure;
